import * as React from "react";
import { useQueryClient } from "react-query";

export const useInvalidateAllActiveQueries = () => {
  const queryClient = useQueryClient();
  return React.useCallback(() => {
    return Promise.all([queryClient.invalidateQueries({ active: true })]);
  }, [queryClient]);
};
